import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/71/thumb-landscape.png"

const Post71 = ({ data: { allCategoryJson, postsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>ご利用を検討している方から、よくこんな声をいただきます。「FAQは読んだけど、なんか不安が残る」と。<br></br>
          FAQは疑問に答えてはいますが、「実際のところ」という感覚まではなかなか届きません。そこで今回は、よくある疑問10個に担当者として率直にお答えします。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;Q1. 本当に本物ですか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;Q2. 届くバッグの状態はどうですか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;Q3. 傷をつけてしまったらどうなりますか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;Q4. 返却期限はないと聞きましたが、本当ですか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;Q5. 解約はどうやってするのですか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>6 |</span>&nbsp;&nbsp;Q6. どんなブランドが借りられますか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>7 |</span>&nbsp;&nbsp;Q7. 人気のバッグはいつも在庫切れでは？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>8 |</span>&nbsp;&nbsp;Q8. 月9,800円（税別）は高いですか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec9" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>9 |</span>&nbsp;&nbsp;Q9. 衛生面は大丈夫ですか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec10" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>10 |</span>&nbsp;&nbsp;Q10. 借りているバッグを気に入ったら買えますか？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec11" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>11 |</span>&nbsp;&nbsp;まとめ</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <div>
          <h2>Q1. 本当に本物ですか？</h2>
        </div>
        <p>はい。すべてのバッグを社内の専門鑑定士が確認しています。また正規品の流通管理に取り組む業界団体「日本流通自主管理協会（AACD）」にも加盟しており、そちらでも鑑定をお願いする場合があります。</p>
        <p>「本物保証」という言葉の裏付けは、社内鑑定士の存在と業界団体加盟という具体的な裏付けがラクサスにはあります。</p>
      </section>
      <section name="sec2" className="section-content">
        <div>
          <h2>Q2. 届くバッグの状態はどうですか？</h2>
        </div>
        <p>バッグによって差があります。これは正直に言います。</p>
        <p>ほぼ新品に近いものから、使い込まれたものまであります。ただ、アプリ内でコンディションについて記載されており、状態を確認した上で選べるので、どの状態のものを手元に置くかは自分でコントロールできます。</p>
        <p>「思っていたより状態が気になった」という声をいただくことがあります。ランクの表示と実物の感覚のズレを小さくしていくことは、継続的に取り組んでいる課題です。</p>
        <p>また、「あまりに思っているものと違っていた」ということであれば、「リセット交換*」というサービスもあります。ぜひ、そちらをご活用ください。</p>
        <p><span className="text-small">*2026年5月時点で行っているサービスです。予告なくサービスを終了する場合があるので、詳しくはアプリをご確認ください。</span></p>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/71/1.png" alt=""/>
      </figure>
      <section name="sec3" className="section-content">
        <div>
          <h2>Q3. 傷をつけてしまったらどうなりますか？</h2>
        </div>
        <p>通常使用による傷や汚れは補償の対象です。財布の出し入れで内側が擦れる、持ち手が少し色落ちする、外側に小さな傷がつく<br></br>
        こういったことは、日常的な使用の範囲として扱います。</p>
        <p>補償外になるのは、穴空き・大きな破損・故意による損傷などです。「これはどちらになりますか？」という疑問があれば、アプリのトーク機能でいつでも聞いてください。返却後に指摘されるより、使いながら確認できる方がお互いにいい、という考えで設計しています。</p>
        <p>また、ペン・口紅はバッグに直接入れるのではなく、ポーチ等に入れてお使いください。バッグの内側汚れを防ぐことができます。</p>
        <p>詳しくは<a href="https://laxus.co/app/pc/blog/security">安心キズ補償</a>をご確認ください。</p>
      </section>
      <section name="sec4" className="section-content">
        <div>
          <h2>Q4. 返却期限はないと聞きましたが、本当ですか？</h2>
        </div>
        <p>本当です。いつ返してもいい、ずっと手元に置いていてもいい。そのペースは完全に自分で決められます。</p>
        <p>「期限があると、使っている間も落ち着かない」——そう感じる方が多いという声から、この設計になっています。気に入ったバッグをそのシーズン使い続けることも、気分で月に何度か替えることも、どちらも自由です。</p>
        <p>なお、同じ月の2回目以降の交換には通常ですと、荷造り手数料1,100円（税込）がかかります。往復の送料は何回でも無料です。</p>
      </section>
      <section name="sec5" className="section-content">
        <div>
          <h2>Q5. 解約はどうやってするのですか？</h2>
        </div>
        <p>アプリ内から手続きが完結します。電話は不要です。最低利用期間の縛りもなく、1ヶ月目でも解約できます。<br></br>
        お手元のバッグは、お届けした際の配送箱に返却伝票が付いていますのでそちらをお使いください。</p>
        <p>「解約しにくいサービスじゃないか」という疑念はよくわかります。ラクサスは「気軽に試して、合わなければ止められる」という前提で設計しています。</p>
      </section>
      <section name="sec6" className="section-content">
        <div>
          <h2>Q6. どんなブランドが借りられますか？</h2>
        </div>
        <p>エルメス、シャネル、ルイ・ヴィトン、セリーヌ、グッチ、プラダ、フェンディなど60以上のブランド、約30,000点のバッグが揃っています。会員登録（無料）後にアプリ内で全点を閲覧できます。入会前に「借りたいバッグがあるか」を確認してから決めることも可能です。</p>
      </section>
      <section name="sec7" className="section-content">
        <div>
          <h2>Q7. 人気のバッグはいつも在庫切れでは？</h2>
        </div>
        <p>人気モデルは貸出中になっていることがあります。これは正直に認めます。</p>
        <p>ただ、同じモデルでも複数の在庫があるものも多く、「ずっと借りられない」という状況は少ないです。どうしても欲しいモデルがある場合、アプリの「お気に入り」ボタンをクリックしてください。バッグが戻り再度公開になるタイミングで、アプリへ通知が届きます。<br></br>
        また、日々バイヤーがトレンドバッグの買い入れを行っています。「新しいバッグの入荷をアプリで確認するのが楽しみ」というお声もいただいています。</p>
      </section>
      <section name="sec8" className="section-content">
        <div>
          <h2>Q8. 月9,800円（税別）は高いですか？</h2>
        </div>
        <p>感じ方は人によって違うと思います。ただ、比較の軸として：エルメスやシャネルのバッグを購入すると数十万円〜100万円超。維持コスト（クリーニング・保管・修理）も加わります。月9,800円でそれらが含まれると考えると、バッグを所有するより低コストになる場面は多くあります。</p>
        <p>「元を取れるか」より「自分の使い方に合うか」で判断するのが正直なところだと思います。気になっているバッグを試してから購入を決める、とっかえひっかえで色々試す、という使い方をされている方が多くいます。</p>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/71/2.png" alt=""/>
      </figure>
      <section name="sec9" className="section-content">
        <div>
          <h2>Q9. 衛生面は大丈夫ですか？</h2>
        </div>
        <p>返却のたびに専門スタッフによるクリーニングを実施しています。拭き取り・クリーニング・オゾン除菌装置での除菌消毒など、バッグの素材に合わせたケアを行い、次のユーザーへお届けします。</p>
        <p>内側のクリーニングについても対応していますが、バッグの素材・状態によって対応範囲が変わる場合があります。気になる点があればお届け前にトークでご確認いただけます。</p>
      </section>
      <section name="sec10" className="section-content">
        <div>
          <h2>Q10. 借りているバッグを気に入ったら買えますか？</h2>
        </div>
        <p>対象バッグに限り、マイページから購入手続きが可能です。<br></br>
        ただし、すべてのバッグが購入できるわけではありません。バッグオーナーの意向により販売していないものもあります。</p>
        <p>「借りているバッグ以外も購入して手元に置きたい」という場合は、ラクサスが運営するセカンドハンドサイト「<a href="https://lax-mochi.com/app/shop/home" target="_blank">ラクモチ（lax-mochi.com）</a>」もご活用ください。ラクサスで流通してきた鑑定済みのバッグを購入できるので、品質面での安心感はラクサスと同じです。</p>
      </section>
      <figure className="mt8">
          <StaticImage src="../../images/posts/71/3.png" alt=""/>
      </figure>
      <section name="sec11" className="section-content">
        <div>
          <h2>まとめ</h2>
        </div>
        <p>10個の疑問を並べてみると、多くが「不安を取り除けるかどうか」に集約されることに気づきます。本物かどうか、状態はどうか、傷をつけたらどうなるか、解約できるか——すべて、安心して使い始められるかどうか、という問いです。</p>
        <p>その不安に正直に向き合い続けることが、サービスとして大事なことだと思っています。</p>
        <p>まずはアプリを無料でダウンロードして、どんなバッグが揃っているか見てみてください。<br></br>
        「このバッグ、使ってみたいな」と思える一点が見つかったら、そのときが始め時です。</p>
        <a href="https://laxus.co/dl" className="view-all-button">アプリを無料でダウンロードしてバッグを見てみる</a>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post71

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 71}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
